// extracted by mini-css-extract-plugin
export default {"root":"ActionPriorityMatrix_root__jhB0b","image":"ActionPriorityMatrix_image__XcCcc","children":"ActionPriorityMatrix_children__V65Uh"};